module.exports = __webpack_public_path__ + "img/check.2d409852.svg";